// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
const TemplatesApi = ApiFactory.get('templates');

const fetchAll = async ( { commit }, qs) => {
  const { data } = await TemplatesApi.getAll(qs);
  commit('SET_DATA', data);
};
export default {
  fetchAll
};
